export default {
  hierarchy: {
    title: "Filter by product hierarchy",
    clear: "Clear filter",
    kind_atc: "ATC",
    kind_ah: "Homogeneous group",
    kind_spr: "Reference-price set",
    kind_pa: "Active ingredient",
    kind_lab: "Marketing authorisation holder",
    kind_nregistro: "Registration no.",
    placeholder_atc: "e.g. C09CA",
    placeholder_ah: "group code or name",
    placeholder_spr: "e.g. F206",
    placeholder_pa: "e.g. Olmesartan",
    placeholder_lab: "e.g. Daiichi Sankyo",
    placeholder_nregistro: "e.g. 75012",
  },
};
